import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { BinsVolumeDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

const undeliveredStatuses = [
  {
    value: 0,
    label: "Creat",
  },
  {
    value: 1,
    label: "Scanat in masina",
  },
  {
    value: 2,
    label: "Scanat in nod",
  },
];

const binsStatuses = [
  {
    value: 1,
    label: "Nefinalizate",
    statuses: undeliveredStatuses,
  },
  {
    value: 0,
    label: "Toate",
  },
  {
    value: 3,
    label: "Inchis cu neconformitati",
  },
  {
    value: 4,
    label: "Inchis fara neconformitati",
  },
];

export const getBinsStatusLabel = (status: number) => {
  const undeliveredBins = binsStatuses.find((bin) => bin.value === 1);
  const undeliveredBinsStatus = undeliveredBins?.statuses?.find(
    (item) => item.value === status,
  );

  if (undeliveredBinsStatus) {
    return undeliveredBinsStatus.label;
  }

  const normalStatus = binsStatuses.find((bin) => bin.value === status);
  return normalStatus?.label ?? "-";
};

export const binsVolumeTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. volum",
    value: "nrVolum",
    maxW: 50,
    withSearch: true,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Pct. ridicare",
    value: "punct_ridicare",
    minW: 125,
  },
  {
    label: "Adresa ridicare",
    value: "adresa_ridicare",
    minW: 125,
  },
  {
    label: "Nod-Preluare",
    value: "nodPreluare",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
    withFilter: binsStatuses,
  },
  {
    label: "Data operatie",
    value: "data_operatie",
    minW: 125,
  },
  {
    label: "Nr. binuri",
    value: "count_binuri",
    minW: 125,
  },
];

export const getBinsVolumeTableData = (
  data: BinsVolumeDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.nr_volum,
      crudData: item,
      data: [
        {
          title: item.nr_volum,
        },
        {
          title: item.client,
        },
        {
          title: item.punct_ridicare,
        },
        {
          title: item.adresa_ridicare,
        },
        {
          title: item.nod_preluare,
        },
        {
          title: item.nod_destinatie,
        },
        {
          badges: [
            {
              badgeText: getBinsStatusLabel(item.status),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.data_operatie
                ? getDateAndTime(item.data_operatie)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: `Binuri x ${item.count_binuri}`,
              badgeColor: "primary",
            },
          ],
        },
      ],
    };
  });
